export default __webpack_public_path__ + "30d2027ba7c16378612e25af3d4e95e3.png";